import lodash from "lodash";
const normalizeNodesIds = (nodes) => {
  let i = 0;
  if (!nodes) {
    return void 0;
  }
  const normalizeIds = (nodes2) => {
    if (nodes2?.length === 0) {
      return [];
    }
    return nodes2?.map((node) => {
      const { id: _, nodes: nodes3, ...rest } = node;
      return {
        ...rest,
        id: `${i++}`,
        ...nodes3 && { nodes: normalizeIds(nodes3) }
      };
    });
  };
  return normalizeIds(nodes);
};
const isRichContentEqual = (a = { nodes: [] }, b = { nodes: [] }) => {
  const aNormalized = JSON.parse(JSON.stringify(a));
  const bNormalized = JSON.parse(JSON.stringify(b));
  if (!lodash.isEqual(aNormalized.documentStyle, bNormalized.documentStyle)) {
    return false;
  }
  if (aNormalized.nodes?.length !== bNormalized.nodes?.length) {
    return false;
  }
  const aNodes = normalizeNodesIds(aNormalized.nodes);
  const bNodes = normalizeNodesIds(bNormalized.nodes);
  if (!lodash.isEqual(aNodes, bNodes)) {
    return false;
  }
  return true;
};
export {
  isRichContentEqual
};
//# sourceMappingURL=is-rich-content-equal.js.map
